(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pr-media"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".custom-tabs .tab-title");
  const contents = document.querySelectorAll(".custom-tabs .tab-content");

  // Function to set the active tab on page load
  function setActiveTab() {
    let activeTabFound = false;

    // Loop through the tabs to find the first non-empty tab
    tabs.forEach((tab, index) => {
      const target = tab.getAttribute("data-tab");
      const content = document.getElementById(target);

      if (content && content.textContent.trim() !== "") {
        if (!activeTabFound) {
          // If this tab has content and no active tab was found, activate it
          tab.classList.add("active");
          content.classList.add("active");
          activeTabFound = true;
        }
      }
    });

    // If no active tab was found, activate the second tab (if it exists)
    if (!activeTabFound && tabs.length > 1) {
      tabs[1].classList.add("active");
      contents[1].classList.add("active");
    }
  }

  // Call setActiveTab to ensure the correct tab is active on page load
  setActiveTab();

  // Tab switching functionality on click
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      tabs.forEach((t) => t.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
